import type {
  ConsumerStats,
  DailyPerformance,
  LastMonthRevenue,
  MonthlyEarnings,
} from '@/domain/performance/Performance'
import type { PerformanceRepository } from '@/domain/performance/PerformanceRepository'
import type { AgentId } from '@/domain/shared/Brand'
import { API_PATHS } from '@/infrastructure/http/ApiPaths'
import type { HttpClient } from '@/infrastructure/interfaces/HttpClient'
import {
  toDailyPerformanceList,
  toLastMonthRevenue,
  toMonthlyEarnings,
} from '@/infrastructure/mapper/ApiToDomainMapper'
import { compilePath } from '@/shared/PathUtils'

export class HttpPerformanceRepository implements PerformanceRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getLast7DaysEarnings(agentId: AgentId): Promise<DailyPerformance[]> {
    const response = await this.httpClient.request<unknown>({
      path: compilePath(API_PATHS.PERFORMANCE.LAST_7_DAYS_REVENUE, { agentId }),
      method: 'GET',
    })
    return toDailyPerformanceList(response)
  }

  async getMonthlyEarnings(agentId: AgentId): Promise<MonthlyEarnings> {
    const response = await this.httpClient.request({
      path: compilePath(API_PATHS.PERFORMANCE.MONTHLY_REVENUE, { agentId }),
      method: 'GET',
    })
    return toMonthlyEarnings(response)
  }

  async getLastMonthRevenue(agentId: AgentId): Promise<LastMonthRevenue> {
    const response = await this.httpClient.request({
      path: compilePath(API_PATHS.PERFORMANCE.LAST_MONTH_REVENUE, { agentId }),
      method: 'GET',
    })
    return toLastMonthRevenue(response)
  }

  async getConsumersCount(agentId: AgentId): Promise<ConsumerStats> {
    return await this.httpClient.request<ConsumerStats>({
      path: compilePath(API_PATHS.PERFORMANCE.CONSUMERS_COUNT, { agentId }),
      method: 'GET',
    })
  }
}
